export const typeSafeObjectEntries = <
  T extends Record<K, unknown>,
  K extends string | number | symbol,
  Value extends NonNullable<T[keyof T]>,
>(
  obj: T
): [keyof T, Value][] => {
  return Object.entries(obj) as [keyof T, Value][];
};
